// **** import modules ****
import app, { Klass, csl, vuwer } from "@@assets/scripts/common";
import "@pressmedia/vuwcolony";
import onChangeState from "./_onChangeState";
import "./_list";


// **** process ****
app.gaAutoSendPageview = false;

vuwer.setProp({
	...onChangeState,
	childSections: [],
	onReady($window) {
		this.getChildren().forEach(vuw => {
			if( vuw instanceof Klass("Vuw") && (/Section$/).test(vuw.name) ) {
				this.childSections.push( vuw.name.replace(/Section$/, "") );
			}
		});
	}
});

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

app.exec();
